import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const AWARD_NODE_FRAGMENT = gql`
  fragment AwardNodeFragment on AwardNode {
    ...MetadataNodeFragment

    children {
      ...MetadataNodeFragment

      children {
        ...MetadataNodeFragment
      }
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default AWARD_NODE_FRAGMENT
